import { SemiLAM2 } from "../google/types";
import { collectionListItemToGoogleSku, getPriceFromSku, verifySingleProductAndSku } from "../google/utils";

function addToCart(event: string, data: SemiLAM2) {
    const items = collectionListItemToGoogleSku(data.payload.collections.products);

    return {
        event,
        data: {
            value: items[0],
            currency: data.context.app.currency,
            items
        }
    }
}

function purchase(event: string, data: SemiLAM2) {
    const transaction = data.payload.collections["transaction"];
    if (!transaction) {
        throw new Error("Transaction collection missing");
    }
    const items = collectionListItemToGoogleSku(transaction.products);
    return {
        event,
        data: {
            currency: data.context.app.currency,
            value: transaction.total.subTotal,
            transaction_id: transaction.id,
            items
        }
    }
}

function pageView(event: string, data: SemiLAM2) {
    return {
        event,
        data: {}
    }
}

function emailSignup(event: string, data: SemiLAM2) {
    return {
        event,
        data: {
            currency: data.context.app.currency,
        }
    }
}

function customerPurchaseType(event: string, data: SemiLAM2) {
    return {
        event,
        data: {}
    }
}

export default {
    "add-to-cart": {
        name: "add_to_cart",
        handler: addToCart,
    },
    "purchase": {
        name: "purchase",
        handler: purchase,
        action: "purchase",
        additionalHandlers: [
            customerPurchaseType
        ]
    },
    "page-view": {
        name: "pageView",
        handler: pageView
    },
    "email-signup": {
        name: "emailSignup",
        handler: emailSignup
    }
}